module.exports = __webpack_public_path__ + "img/icon-filter.7ede81da.svg";